import { z } from 'zod'

import { makeGenericZodErrorMessage } from '@/utils/make-generic-zod-error-message'

const dateSchema = z.coerce
  .date(makeGenericZodErrorMessage('A data é obrigatória.'))
  .min(new Date('1900-01-01'), { message: 'Data muito antiga.' })
  .transform((value) => value.toJSON().split('T')[0])

export const schema = z.object({
  pulverization_treatment: z.enum(
    ['cromai_results', 'total_area', 'no_pulverizated'],
    makeGenericZodErrorMessage('Campo obrigatório'),
  ),
  date: z
    .object({
      start_date: dateSchema,
      end_date: z.union([dateSchema, z.string()]),
    })
    .refine(
      (data) => {
        if (!data.end_date) return true
        return data.start_date <= data.end_date
      },
      {
        message: 'Data final deve ser maior que a data inicial.',
        path: ['end_date'],
      },
    )
    .transform((value) => ({
      start_date: value.start_date,
      end_date: value.end_date || value.start_date,
    })),
  description: z.string().max(600, { message: 'Máximo de 600 caracteres' }),
})

export type DefaultConfirmPulverizationForm = z.infer<typeof schema>
